<script>

</script>

<div class="main">
    <slot></slot>
</div>

<style>
	.main {
		text-align: center;
		padding-top: 2em;
		padding-left: 1em;
		padding-right: 1em;
		max-width: 720px;
		margin: 0 auto;
	}
</style>